const Config = APP_CONFIG; // eslint-disable-line no-undef

/**
 * Application Global Configuration.
 * That object is dynamically created and injected by Webpack.
 */
export default Config;
